import React from "react";
import { Switch } from "react-router-dom";
import MarketingV2Home from "components/Pages/Admin/MarketingV2/MarketingV2Home";
import BatchDetails from "components/Pages/Admin/MarketingV2/BatchDetails";
import BatchEmail from "components/Pages/Admin/MarketingV2/BatchEmail";
import BatchText from "components/Pages/Admin/MarketingV2/BatchText";
import BatchPush from "components/Pages/Admin/MarketingV2/BatchPush";
import BatchList from "components/Pages/Admin/MarketingV2/BatchList";
import BatchReview from "components/Pages/Admin/MarketingV2/BatchReview";
import BatchAnalytics from "components/Pages/Admin/MarketingV2/batchAnalytics";
import AdminRouteRaw from "../../AuthRoutes/Admin";

const rootPath = 'v2-marketing';

const AdminRoute = (props) => (
  <AdminRouteRaw renderLayout={false} {...props} />
);

const AppRoutes = () => (
  <Switch>
    <AdminRoute exact path={`/${rootPath}/batch-details/:batchId`} component={BatchDetails} />
    <AdminRoute exact path={`/${rootPath}/batch-email/:batchId`} component={BatchEmail} />
    <AdminRoute exact path={`/${rootPath}/batch-text/:batchId`} component={BatchText} />
    <AdminRoute exact path={`/${rootPath}/batch-push/:batchId`} component={BatchPush} />
    <AdminRoute exact path={`/${rootPath}/batch-list/:batchId`} component={BatchList} />
    <AdminRoute exact path={`/${rootPath}/batch-review/:batchId`} component={BatchReview} />
    <AdminRoute exact path={`/${rootPath}/analytics`} component={BatchAnalytics} />
    <AdminRoute exact path={`/${rootPath}/`} component={MarketingV2Home} />
  </Switch>
);

export default AppRoutes;
